var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M3.796 2.156A9.971 9.971 0 0 1 10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.995 9.995 0 0 1-8.653-4.984 1 1 0 1 1 1.73-1.005A8 8 0 1 0 5.353 3.487l1.617.924a.5.5 0 0 1-.111.915L1 7l.84-5.887a.5.5 0 0 1 .88-.249l1.076 1.292zm8.911 9.137a1 1 0 0 1-1.414 1.414l-2-2a1 1 0 0 1-.187-1.154l2-4a1 1 0 0 1 1.788.894l-1.677 3.356 1.49 1.49z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.e26c6946179cb0e30c890b2fc21f54d9.svg";
export { ForwardRef as ReactComponent };